export const META_MASK_ERROR_CODE = {
    REJECTED_BY_USER: 4001,
    PENDING_REQUEST: -32002
};
